import axios from 'axios';
import AjaxResponseInterface from '@/interfaces/AjaxResponseInterface';
import CityInterface from '@/interfaces/CityInterface';
import StreetInterface from '@/interfaces/StreetInterface';

export default {
  getCities(postcode: string | number): Promise<CityInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<CityInterface[]>(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'enet',
          endpoint: 'cities',
          postcode,
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;
        resolve(ajaxResponseData.cities as CityInterface[]);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getStreets(postcode: string | number): Promise<StreetInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<StreetInterface[]>(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'enet',
          endpoint: 'streets',
          postcode,
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;
        resolve(ajaxResponseData.streets as StreetInterface[]);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getCitiesAndStreets(postcode: string | number)
    : Promise<{
      postcode: string | number,
      cities: CityInterface[],
      streets: StreetInterface[],
    }> {
    return new Promise((resolve, reject) => {
      axios.get<CityInterface[]>(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'enet',
          endpoint: 'cities-and-streets',
          postcode,
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;
        resolve({
          postcode,
          streets: ajaxResponseData.streets as StreetInterface[],
          cities: ajaxResponseData.cities as CityInterface[],
        });
      }).catch((e) => {
        reject(e);
      });
    });
  },
};
